import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = 'oldPages/transfer-statements/index.html';

const links: Record<string, string> = {
  list: '/infoTrac/transfer-statements/accounts-list',
};

function TransferStatements() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const list = iframeDocument.getElementsByClassName('submitBtn');

      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          list[i].addEventListener('click', () => navigate(links.list));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      title="transfer-statements"
      src={path}
      className="z-[100] relative"
      width="100%"
      height="700px"
    />
  );
}

export default TransferStatements;
